import type { ApiRequest } from "@/api/types";
import { httpAuth } from "@/api/httpAuth";

export type UnreadMessageCountResponse = {
  unread_count: number;
};

type MessagingRequestsTyped = {
  fetch_unread_message_count: ApiRequest<UnreadMessageCountResponse>;
};

export const messagingRequestsTyped: MessagingRequestsTyped = {
  fetch_unread_message_count: function ({ context } = {}) {
    return httpAuth
      .post("/v1/messaging/unread_message_count", { context })
      .json<UnreadMessageCountResponse>();
  },
};
